import React from 'react'
import { compose } from 'ramda'
import { make as MainLayout } from 'reason/common/components/MainLayout.bs'
import { make as SecondaryLayout } from 'reason/common/components/SecondaryLayout.bs'
import { make as MainAppRelay } from 'v5/MainApp.bs'

export default MainAppRelay

export const asLayout = page => <MainAppRelay>{page}</MainAppRelay>
const mainLayout = ({ noPadding = false, flexDirection } = {}) => {
  const Component = page => (
    <MainLayout noPadding={noPadding} flexDirection={flexDirection}>
      {page}
    </MainLayout>
  )

  Component.displayName = 'MainLayout'

  return Component
}

export const withMainLayout = compose(asLayout, mainLayout({}))
export const withMainLayoutNoPadding = compose(asLayout, mainLayout({ noPadding: true }))
export const withMainLayoutFlex = compose(asLayout, mainLayout({ flexDirection: 'column' }))
export const withMainLayoutFlexNoPadding = compose(
  asLayout,
  mainLayout({ flexDirection: 'column', noPadding: true })
)
const secondaryLayout = page => <SecondaryLayout>{page}</SecondaryLayout>

export const withSecondaryLayout = compose(asLayout, secondaryLayout)
